module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-1-0b43c6fbb92cbd6677d6cc270cfbc4db.svg";